import script from "./AgendaView.vue?vue&type=script&setup=true&lang=js"
export * from "./AgendaView.vue?vue&type=script&setup=true&lang=js"

import "./AgendaView.vue?vue&type=style&index=0&id=14821aae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14821aae"]])

export default __exports__